import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sp-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']

})
export class ButtonComponent implements ButtonInterface {
  @Input() label: string = '';
  @Input() type: string = '';
  @Input() size: string = 'default';
  @Input() style: string = 'button-default';
  @Input() state: string = 'default';
  @Input() icon: string = null;
  @Input() disabled: boolean = false;
  @Input() status: string = '';
  @Input() routerLink = null;

  @Output() clickAction = new EventEmitter<any>();

  onClickEvent(event) {
    if (this.routerLink) {
      const isExternalLink = this.routerLink ? this.routerLink.indexOf('http') >= 0 || this.routerLink.indexOf('://') > 0 : null;
      if (isExternalLink) {
        window.location.href = this.routerLink;
      }
      console.log(this.routerLink);

      this.router.navigate([this.routerLink]);
    }
    this.clickAction.emit(event);
  }

  constructor(public router: Router) {}
}

export interface ButtonInterface {
  label?: string;
  type?: string;
  size?: string;
  style?: string;
  status?: string;
  state?: string;
  icon?: string;
  action?: any;
  disabled?: boolean;
}